import React from 'react';
import { ColorPicker } from '../../config/ColorPicker';
import { hourToMin } from '../../utils/helper';

export const ProductionInfoPanel = ({ productionList, params }) => {
  const infoPanelBg =
    productionList.productionStatus &&
    ColorPicker.find((color) => color.colorName === productionList.productionStatus.color);
  return (
    <div className="mt-5">
      <h2 className="text-2xl mb-2 text-labelColor">Művelet infó panel</h2>
      <div
        className="py-5 rounded-lg flex justify-around shadow-md"
        style={{
          background: infoPanelBg ? infoPanelBg?.colorBgCode : '#f3f4f6',
          color: infoPanelBg ? infoPanelBg?.textColor : '#607d8b',
        }}
      >
        <div>
          <p className="font-semibold text-lg">Késztermék neve</p>
          <p className="text-lg">{productionList.articleName}</p>
        </div>
        <div>
          <p className="font-semibold text-lg">Késztermék cikkszáma</p>
          <p className="text-lg">{productionList.articleNumber}</p>
        </div>
        <div>
          <p className="font-semibold text-lg">Művelet azonosító</p>
          <p className="text-lg">{productionList.operationIdlabel}</p>
        </div>
        <div>
          <p className="font-semibold text-lg">Művelet neve</p>
          <p className="text-lg">{productionList.operationName}</p>
        </div>
        <div>
          <p className="font-semibold text-lg">Tervezett idő</p>
          <p className="text-lg">
            {productionList && productionList.plannedQty
              ? productionList.plannedQty + ' ' + productionList.operationQuantityUnit
              : ''}
          </p>
        </div>
        <div>
          <p className="font-semibold text-lg"> Tény idő</p>
          <p className="text-lg">
            {productionList
              ? params.QUANTITY_UNIT_HOUR_CODE === productionList.operationQuantityUnit
                ? Math.round(productionList.total?.timeSpent * 100) / 100 + ' ' + productionList.operationQuantityUnit
                : Math.round(productionList.total?.timeSpentInMin * 100) / 100 +
                  ' ' +
                  productionList.operationQuantityUnit
              : ''}
          </p>
        </div>
        <div>
          <p className="font-semibold text-lg">Tervezett mennyiség</p>
          <p className="text-lg">
            {productionList && productionList?.productionQuantity
              ? productionList.productionQuantity + ` ${productionList?.quantityUnit}`
              : ''}
          </p>
        </div>
        <div>
          <p className="font-semibold text-lg">Tény mennyiség</p>
          <p className="text-lg">
            {productionList && productionList.total?.quantity
              ? productionList.total?.quantity + ` ${productionList?.quantityUnit}`
              : ''}
          </p>
        </div>
      </div>
    </div>
  );
};
